import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";

import {
    ITCIVpnConnection,
    ITCIVpnConnectionBase,
    ITCIVpnConnectionBrief,
    SERVICE_URLS
} from "@tci/common";

@Injectable()
export class NgSecurityService {

    constructor(
        private http: Http
    ) {}

    public getVpnConnections(username: string): Observable<ITCIVpnConnectionBrief[]> {
        const url = `${SERVICE_URLS.VPN}/users/${username}/vpnconnections`;

        return this
            .http
            .get(url)
            .map((res: Response) => res && res.json() || [])
            .catch(error => {
                console.log("Error getting VPN connections, ", error);
                throw error;
            });
    }

    public getVpnConnectionById(username: string, vpnConnectionId: string): Observable<ITCIVpnConnection> {
        const url = `${SERVICE_URLS.VPN}/users/${username}/vpnconnections/${vpnConnectionId}`;

        return this
            .http
            .get(url)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error getting VPN connection by ID: ${vpnConnectionId}, `, error);
                throw error;
            });
    }

    public addVpnConnection(username: string, vpnConnection: ITCIVpnConnectionBase): Observable<any> {
        const url = `${SERVICE_URLS.VPN}/users/${username}/vpnconnections`;

        return this
            .http
            .post(url, vpnConnection)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log("Error adding VPN connection, ", error);
                throw error;
            });
    }

    public updateVpnConnection(username: string, vpnConnection: ITCIVpnConnection): Observable<any> {
        const url = `${SERVICE_URLS.VPN}/users/${username}/vpnconnections/${vpnConnection.vpnConnectionId}`;

        return this
            .http
            .put(url, vpnConnection)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error updating VPN connection with ID: , ${vpnConnection.vpnConnectionId}`, error);
                throw error;
            });
    }

    public deleteVpnConnection(username: string, vpnConnectionId: string): Observable<any> {
        const url = `${SERVICE_URLS.VPN}/users/${username}/vpnconnections/${vpnConnectionId}`;

        return this
            .http
            .delete(url)
            .map((res: Response) => res && res.json() || true)
            .catch(error => {
                console.log(`Error deleting VPN connection with id: ${vpnConnectionId}`, error);
                throw error;
            });
    }

    public attachVpnConnection(sandboxId: string, appId: string, vpnConnectionId: string): Observable<any> {
        const url = `${SERVICE_URLS.VPN}/sandboxes/${sandboxId}/applications/${appId}/vpnConnectionId/${vpnConnectionId}`;
        return this
            .http
            .put(url, {})
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(
                    `Error attaching VPN connection with id: ${vpnConnectionId} to app with id: ${appId}`,
                    error
                );
                throw error;
            });
    }

    public detachVPNConnection(sandboxId, appId): Observable<any> {
        const url = `${SERVICE_URLS.VPN}/sandboxes/${sandboxId}/applications/${appId}/vpnConnectionId`;

        return this
            .http
            .delete(url)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error detaching VPN connection from app with id: ${appId}`, error);
                throw error;
            });
    }

    /**
     * /api/v1/security/tibtunnel/accessKeys
     */
    public getTibTunnelAccessKeys(id?: string): Observable<string[]> {
        let url = `${SERVICE_URLS.TIB_TUNNEL}/accesskeys`;
        if (id) {
          url += `?appId=${id}`;
        }
        return this
            .http
            .get(url)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error getting Tib tunnel access keys`, error);
                throw error;
            });
    }

    /**
     * /api/v1/security/tibtunnel/sandboxes/:sandboxId/applications/:appId/accesskeys/:accessKey
     * @param sandboxId
     * @param appId
     * @param accessKey
     */
    public updateTibTunnelAccessKey(sandboxId: string, appId: string, accessKey: string): Observable<any> {
        const url = `${SERVICE_URLS.TIB_TUNNEL}/sandboxes/${sandboxId}/applications/${appId}/accesskeys/${accessKey}`;

        return this
            .http
            .put(url, {})
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error updating Tib tunnel access key for app with id: ${appId}`, error);
                throw error;
            });
    }

    /**
     * /api/v1/security/tibtunnel/sandboxes/:sandboxId/applications/:appId/accesskeys
     * @param sandboxId
     * @param appId
     */
    public detachTibTunnelAccessKeys(sandboxId: string, appId: string): Observable<any> {
        const url = `${SERVICE_URLS.TIB_TUNNEL}/sandboxes/${sandboxId}/applications/${appId}/accesskeys`;

        return this
            .http
            .delete(url)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error detaching Tib tunnel access keys from app with id: ${appId}`, error);
                throw error;
            });
    }
}

// if (typeof angular !== "undefined") {
//     angular
//         .module("main")
//         .factory("troposCommonServiceRestfulAPITCIVPN", downgradeInjectable(NgVpnSecurityService) as any);
// }
